import { ErrorHandler, inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { GlobalErrorHandler } from './global-error-handler.service';

@Injectable()
export class SentryGlobalErrorHandler implements ErrorHandler {
  private readonly globalErrorHandler = inject(GlobalErrorHandler);
  private readonly sentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
  });

  handleError(error: unknown): void {
    // Send to Sentry for monitoring
    this.sentryErrorHandler.handleError(error);

    // Also run the app's own error handler for user-facing notifications
    this.globalErrorHandler.handleError(error as Error);
  }
}
